<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      v-if="ativo"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :color="item.pedido_compra_fracionada_id ? 'blue' : ''"
          v-bind="attrs"
          v-on="on"
          icon
        >
          <v-icon size="28px">mdi-alpha-f-box-outline</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-toolbar dark flat color="#042333" height="50px">
          <v-btn icon dark @click="fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title class="subtitle-1">
            Fracinamento do Pedido Nº <b>{{ item.idpedido }}</b>
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-0">
          <v-row
            class="mx-1 mt-0 mb-0 pedido-fracionado"
            justify="end"
            v-if="parcelas.length == 0 || recalc"
          >
            <v-col cols="auto" class="pb-0">
              <v-select
                v-model="form.parcela"
                :items="selects.parcelas"
                dense
                label="Qtde. de pedidos*"
                outlined
                :error-messages="parcelasErrors"
                @input="$v.form.parcela.$touch()"
                @blur="$v.form.parcela.$touch()"
              ></v-select>
            </v-col>

            <v-col cols="3" class="pb-0">
              <v-text-field
                v-model="form.tempo"
                v-currency="number"
                dense
                label="Tempo médio entre pedidos (dias)*"
                outlined
                :error-messages="tempoErrors"
                @input="$v.form.tempo.$touch()"
                @blur="$v.form.tempo.$touch()"
              ></v-text-field>
            </v-col>

            <v-col cols="1" class="pb-0">
              <v-text-field
                v-model="form.diautil"
                v-currency="number"
                dense
                label="Dias Úteis*"
                outlined
                :error-messages="diautilErrors"
                @input="$v.form.diautil.$touch()"
                @blur="$v.form.diautil.$touch()"
              ></v-text-field>
            </v-col>

            <v-col cols="auto" class="pb-0">
              <v-btn color="success" dark height="40px" @click="calcular([])">
                Calcular
              </v-btn>
            </v-col>
          </v-row>

          <v-row class="mx-1 mt-0 mb-2 pedido-fracionado" justify="end" v-else>
            <v-col cols="auto" class="mb-1">
              <v-btn color="white" height="42px" @click="excluir" class="ml-2">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </v-col>

            <v-col cols="auto" class="mb-1" v-if="editado">
              <v-btn color="white" height="42px" @click="recalc = true">
                Re-Calcular
              </v-btn>
            </v-col>

            <v-col cols="auto" class="mb-1" v-if="editado">
              <v-btn
                color="#042333"
                class="white--text"
                height="42px"
                @click="salvar()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>

          <v-card-text
            class="px-0 pt-0"
            style="height: calc(100vh - 128px); overflow-y: auto"
          >
            <v-data-table
              v-model="selected"
              :items="produtos"
              :headers="headers.produto"
              item-key="idproduto"
              hide-default-footer
              class="elevation-3 mx-4 mt-1 pt-0 table-pedido-fracionado"
              v-if="parcelas.length == 0 || recalc"
              show-select
              :fixed-header="true"
              height="calc(100vh - 162px)"
              :items-per-page="-1"
            >
            </v-data-table>

            <template v-for="gitens in itensGroup" v-else>
              <v-data-table
                :items="gitens"
                :headers="headers.parcelas"
                item-key="i"
                hide-default-footer
                disable-pagination
                fixed-header
                class="elevation-3 mx-4 mt-1 mb-2"
                :key="gitens.idproduto"
              >
              </v-data-table>
            </template>
          </v-card-text>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      recalc: false,
      editado: false,
      selected: [],
      qtdeRules: [],
      headers: {
        produto: [
          { text: "ID", value: "idproduto" },
          { text: "Produto", value: "descricao_produto" },
          { text: "Qtde Pedido", value: "v_qtde_pedido", align: "center" },
          { text: "Preço Atual", value: "v_preco_custo", align: "center" },
          { text: "Saldo Inicial", value: "v_estoque", align: "center" },
          {
            text: "Tempo Resuprimento",
            value: "v_tempo_medio_ressuprimento",
            align: "center",
          },
          {
            text: "Consumo Mensal",
            value: "v_consumo_medio_mensal",
            align: "center",
          },
        ],
        parcelas: [
          { text: "Produto", value: "idproduto", align: "center" },
          { text: "Parcela", value: "parcela", align: "center" },
          { text: "Data de Emissão", value: "data_emissao", align: "center" },
          {
            text: "Saldo no dia do Pedido",
            value: "v_saldo_inicial",
            align: "center",
          },
          {
            text: "Qtde Solicitada",
            value: "v_qtde_solicitada",
            width: "140px",
            align: "center",
          },
          {
            text: "Previsão de Chegada",
            value: "data_chegada",
            align: "center",
          },
          {
            text: "Saldo Futuro (dia de chegada)",
            value: "v_saldo_futuro",
            align: "center",
          },
          {
            text: "Consumo Mensal",
            value: "v_consumo_medio_mensal",
            align: "center",
          },
          { text: "COB", value: "v_cob", align: "center" },
          { text: "", value: "action", align: "center" },
        ],
      },
      qtde: {
        currency: null,
        distractionFree: { hideCurrencySymbol: false },
        precision: 4,
        allowNegative: false,
        valueAsInteger: false,
        autoDecimalMode: false,
      },
      number: {
        currency: null,
        distractionFree: { hideCurrencySymbol: false },
        precision: 0,
        allowNegative: false,
        valueAsInteger: true,
        autoDecimalMode: true,
      },
    };
  },
  validations: {
    form: {
      parcela: { required },
      tempo: { required },
      diautil: { required },
    },
  },
  computed: {
    ...mapGetters("pedidoFracionado", [
      "selects",
      "produtos",
      "itens",
      "parcelas",
      "form",
      "ativo",
    ]),
    parcelasErrors() {
      const errors = [];
      if (!this.$v.form.parcela.$dirty) return errors;
      !this.$v.form.parcela.required &&
        errors.push("A qtde. de pedidos é obrigatória.");
      return errors;
    },
    tempoErrors() {
      const errors = [];
      if (!this.$v.form.tempo.$dirty) return errors;
      !this.$v.form.tempo.required &&
        errors.push("O tempo médio entre pedidos é obrigatório.");
      return errors;
    },
    diautilErrors() {
      const errors = [];
      if (!this.$v.form.diautil.$dirty) return errors;
      !this.$v.form.diautil.required &&
        errors.push("O dia útil é obrigatório.");
      return errors;
    },
    itensGroup() {
      return this.ordernar(this.parcelas, "idproduto");
    },
    IDS_PEDIDOS_SELECIONADOS() {
      return this.item.pedidos_consolidados
        ? this.Helpers.arrayColumn(this.item.pedidos_consolidados, "idpedido")
        : this.item.idpedido
    }
  },
  created() {
    if (this.ativo === null) {
      this.$store.dispatch("pedidoFracionado/Ativo")
    }
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.form.parcela = "";
        this.form.diautil = 26;
        this.$store.dispatch(
          "loading/addRequisicao",
          this.$store.dispatch("pedidoFracionado/Itens", {
            idgrupo: this.item.grupo,
            filial: this.item.filial_compra,
            idproduto: this.item.idproduto,
            idpedido: this.IDS_PEDIDOS_SELECIONADOS
          })
        );
      } else {
        this.editado = false;
        this.selected = [];
        this.$emit("fracionado");
      }
      this.$v.$reset();
    },
    produtos() {
      this.selected = this.produtos;
    },
  },
  methods: {
    salvar() {
      this.$store.dispatch(
        "loading/addRequisicao",
        this.$store.dispatch("pedidoFracionado/Store").then(() => {
          this.editado = false;
          this.dialog = false;
        })
      );
    },
    excluir() {
      if (confirm("Deseja remover as parcelas?")) {
        this.$store
          .dispatch("pedidoFracionado/Delete", {
            idgrupo: this.item.grupo,
            filial: this.item.filial_compra,
            idpedido: this.IDS_PEDIDOS_SELECIONADOS
          })
          .then(() => {
            this.dialog = false;
          });
      }
    },
    calcular() {
      this.qtdeRules = [];
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this.recalc = false;
      this.editado = true;
      this.$store.commit("pedidoFracionado/setDisable", this.selected);
      this.$store.dispatch(
        "loading/addRequisicao",
        this.$store.dispatch("pedidoFracionado/Setar", {
          tem: this.form.tempo,
          par: this.form.parcela,
          diautil: this.form.diautil,
          idpedido: this.IDS_PEDIDOS_SELECIONADOS
        })
      );
    },
    fechar() {
      if (this.editado) {
        if (confirm("Existe item a ser salvo, não salvar mesmo assim?")) {
          this.dialog = false;
        }
      } else {
        this.dialog = false;
      }
    },
    ordernar(items, key) {
      return items.reduce(
        (result, item) => ({
          ...result,
          [item[key]]: [...(result[item[key]] || []), item],
        }),
        {}
      );
    },
  }
};
</script>
<style>
.pedido-fracionado input {
  text-align: right !important;
}
.pedido-fracionado
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.875rem;
  height: 39px;
}

.table-pedido-fracionado .v-data-table__checkbox.v-simple-checkbox {
  text-align: center;
}
</style>
